import { Link } from "react-router-dom";
import { PageHero } from "@/components/layout/PageHero";
import { useI18n } from "@/i18n/I18nContext";

// `gone`: removed/unavailable third-party content — friendly page with a way back to the catalogue.
export default function NotFound({ gone = false }) {
  const { t } = useI18n();
  return (
    <div data-testid={gone ? "gone-page" : "not-found-page"}>
      <PageHero eyebrow={t("notFound.eyebrow")} title={t(gone ? "notFound.gone" : "notFound.title")}>
        <Link to={gone ? "/apps" : "/"} className="btn-gold mt-8" data-testid={gone ? "gone-catalogue-link" : "not-found-home-link"}>{t(gone ? "notFound.catalogue" : "notFound.home")}</Link>
      </PageHero>
    </div>
  );
}
